import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { Section } from 'jbc-front/components/Form';
import { BoxTriple } from 'src/components/Form';

import { REDUCER_NAME } from 'src/reducers/employees/employees';
import { getItem } from 'src/reducers/common/itemReducer';
import selector from 'src/utils/Utils';
import { isYearFormat } from 'src/utils/CustomValidators';

import { CustomYearPicker } from './CustomYearPicker';
import TaxCalculationSectionShow from './TaxCalculationSectionShow';

const IncomeTaxAndSSCSectionShow = ({ employeeTaxCalculationSettings }) => {
  const { t } = useTranslation();

  const taxYear = Math.max(...Object.keys(employeeTaxCalculationSettings).map(key => parseInt(key, 10)));
  const [taxCalculationYear, setTaxCalculationYear] = useState(taxYear);

  const isValidDate = currentDate => {
    const datePickerYear = new Date(currentDate).getFullYear();
    // check if taxcalculation data in employeeTaxCalculationSetting is existed,
    return Object.keys(employeeTaxCalculationSettings).includes(datePickerYear.toString());
  };

  const updateTaxCalculationYearDisplay = e => {
    const NewCalculationYear = moment(e).year();
    if (NewCalculationYear in employeeTaxCalculationSettings) {
      setTaxCalculationYear(NewCalculationYear);
    }
  };

  return (
    <div>
      <div style={{ marginLeft: '26px' }}>
        <BoxTriple>
          <CustomYearPicker
            label={t('features.Employees.components.IncomeTaxAndSSCSectionShow.year')}
            name="taxCalculationYear"
            validate={isYearFormat}
            isValidDate={(currentDate, selectedDate) => isValidDate(currentDate, selectedDate)}
            onChange={year => updateTaxCalculationYearDisplay(year)}
            value={taxCalculationYear}
          />
        </BoxTriple>
      </div>
      <Section title={t('features.Employees.components.IncomeTaxAndSSCSectionShow.tax_calculation')}>
        <TaxCalculationSectionShow taxCalculationYear={taxCalculationYear} />
      </Section>
    </div>
  );
};

const mapStateToProps = state => ({
  employeeTaxCalculationSettings: selector(getItem(REDUCER_NAME, state), 'employeeTaxCalculationSettings')
});

export default connect(mapStateToProps)(IncomeTaxAndSSCSectionShow);
